module.exports = __webpack_public_path__ + "img/load.0b61d0e5.png";